import { Job } from './../../models/job.model';
// Angular
import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { ContentService } from '../../../lib/services/contentService';
import { TranslateService } from '@ngx-translate/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
  selector: 'mj-job-info-salary-card',
  templateUrl: './job-info-salary-card.component.html',
  styleUrls: ['./job-info-salary-card.component.scss'],
})
export class JobInfoSalaryCardComponent implements OnInit, OnDestroy {
  formGroup: FormGroup;
  selectedSalaryType: number;
  selectedCommissionSalaryType: number;
  disabledSalaryCommission: number;

  @Input() job: Job;

  @Output() onJobChanged: EventEmitter<Job> = new EventEmitter<Job>();

  private salaryAmountSubscription: Subscription;

  constructor(public translate: TranslateService, public cs: ContentService) {
    this.formGroup = new FormGroup({
      job_salary_amount: new FormControl(''),
    });
  }

  public ngOnDestroy() {
    this.salaryAmountSubscription.unsubscribe();
  }

  public ngOnInit() {
    if (!this.job.salary_type) {
      this.onJobChanged.emit({ ...this.job, salary_type: 0 });
    }
    switch (this.job.salary_type) {
      case 0:
        this.selectedSalaryType = 0;
        this.selectedCommissionSalaryType = 1;
        break;
      case 1:
        this.selectedSalaryType = 1;
        this.selectedCommissionSalaryType = 1;
        break;
      case 2:
        this.selectedSalaryType = 2;
        this.selectedCommissionSalaryType = 0;
        break;
      case 3:
        this.selectedSalaryType = 1;
        this.selectedCommissionSalaryType = 0;
        break;
      case 4:
        this.selectedSalaryType = 0;
        this.selectedCommissionSalaryType = 0;
        break;
      default:
        this.selectedSalaryType = 0;
        return (this.selectedCommissionSalaryType = 1);
    }
    this.formGroup.patchValue({
      job_salary_amount: this.job.salary_amount,
    });
    this.salaryAmountSubscription = this.formGroup
      .get('job_salary_amount')
      .valueChanges.subscribe(val => {
        this.onJobChanged.emit({
          ...this.job,
          salary_amount: parseInt(val, 10),
        });
      });
  }

  isSalaryTypeSelected(value: any): boolean {
    return this.selectedSalaryType === parseInt(value, 10);
  }

  selectSalaryType(value: any): void {
    this.selectedSalaryType = parseInt(value, 10);
    if (this.job.salary_type === 1 && this.job.salary == null) {
      this.selectSalaryLevel(0);
    }
    if (this.selectedSalaryType === 2) {
      this.disabledSalaryCommission = 1;
      this.selectSalaryCommissionType(0);
    } else {
      this.disabledSalaryCommission = -1;
    }
    this.onJobChanged.emit({
      ...this.job,
      salary_type: this.calculateSalaryType(),
    });
  }

  calculateSalaryType(): number {
    switch (this.selectedCommissionSalaryType) {
      case 0:
        switch (this.selectedSalaryType) {
          case 0:
            return 4;
          case 1:
            return 3;
          case 2:
            return 2;
        }
        break;
      case 1:
        switch (this.selectedSalaryType) {
          case 0:
            return 0;
          case 1:
            return 1;
          case 2:
            return 2;
        }
    }
  }

  isSalaryCommissionTypeSelected(value: any): boolean {
    return this.selectedCommissionSalaryType === parseInt(value, 10);
  }

  isSalaryCommissionTypeDisabled(value: any): boolean {
    return this.disabledSalaryCommission === parseInt(value, 10);
  }

  selectSalaryCommissionType(value: any): void {
    this.selectedCommissionSalaryType = parseInt(value, 10);
    this.onJobChanged.emit({
      ...this.job,
      salary_type: this.calculateSalaryType(),
    });
    if (this.job.salary_type === 1 && this.job.salary == null) {
      this.selectSalaryLevel(0);
    }
  }

  selectSalaryLevel(value: any) {
    this.onJobChanged.emit({ ...this.job, salary: parseInt(value, 10) });
  }
}
